import { ConfigProvider, SpinLoading } from 'antd-mobile';
import enUS from 'antd-mobile/es/locales/en-US';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { overlayMergedRegisterKeys } from './utils/registerContext';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import RegisterFromWsPage from './pages/RegisterFromWsPage';
import LoginFromWsPage from './pages/LoginFromWsPage';
import ProfilePage from './pages/ProfilePage';
import MemberQRRedirect from './pages/MemberQRRedirect';
import SignPage from './pages/SignPage';
import WorkerQRRedirect from './pages/WorkerQRRedirect';
import Spring2026QRCodePage from './pages/Spring2026QRCodePage';
import FlashCoupon20260520Page from './pages/FlashCoupon20260520Page';
import NationalDay2026Page from './pages/NationalDay2026Page';
import StoreOpeningClaimPage from './pages/StoreOpeningClaimPage';
import WhatsAppWsRoute from './components/WhatsAppWsRoute';
import './App.css';

function RequireAuth({ children }) {
  const { isAuthenticated, isSessionReady, initialized } = useAuth();
  const location = useLocation();

  if (!initialized || !isSessionReady) {
    return (
      <div className="loading-screen">
        <SpinLoading color="primary" />
        <span>Loading...</span>
      </div>
    );
  }

  if (!isAuthenticated) {
    const next = overlayMergedRegisterKeys(new URLSearchParams(location.search));
    const qs = next.toString();
    return <Navigate to={qs ? `/login?${qs}` : '/login'} replace />;
  }

  return children;
}

function NavigateHomePreserveQuery() {
  const location = useLocation();
  return location.search ? (
    <Navigate to={{ pathname: '/', search: location.search }} replace />
  ) : (
    <Navigate to="/" replace />
  );
}

function RedirectIfAuthenticated({ children }) {
  const { isAuthenticated, isSessionReady, initialized } = useAuth();

  if (!initialized || !isSessionReady) {
    return (
      <div className="loading-screen">
        <SpinLoading color="primary" />
        <span>Loading...</span>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
}

function App() {
  return (
    <ConfigProvider locale={enUS}>
      <AuthProvider>
        <div className="app-shell">
          <Routes>
            <Route
              path="/login"
              element={
                <RedirectIfAuthenticated>
                  <LoginPage />
                </RedirectIfAuthenticated>
              }
            />
            <Route
              path="/loginfromws"
              element={
                <WhatsAppWsRoute>
                  <LoginFromWsPage />
                </WhatsAppWsRoute>
              }
            />
            <Route
              path="/register"
              element={<RegisterPage />}
            />
            <Route
              path="/registerfromws"
              element={
                <WhatsAppWsRoute>
                  <RegisterFromWsPage />
                </WhatsAppWsRoute>
              }
            />
            <Route
              path="/member"
              element={<MemberQRRedirect />}
            />
            <Route
              path="/sign"
              element={<SignPage />}
            />
            <Route
              path="/worker"
              element={<WorkerQRRedirect />}
            />
            <Route
              path="/spring2026"
              element={<Spring2026QRCodePage />}
            />
            <Route
              path="/get-flash-coupon-20260520"
              element={<FlashCoupon20260520Page />}
            />
            <Route
              path="/national-day-2026"
              element={<NationalDay2026Page />}
            />
            <Route
              path="/claim/store-opening"
              element={<StoreOpeningClaimPage />}
            />
            <Route
              path="/"
              element={
                <RequireAuth>
                  <HomePage />
                </RequireAuth>
              }
            />
            <Route
              path="/profile"
              element={
                <RequireAuth>
                  <ProfilePage />
                </RequireAuth>
              }
            />
            <Route path="*" element={<NavigateHomePreserveQuery />} />
          </Routes>
        </div>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
